// import hooks
import { useEffect } from "react";
import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
    RouterProvider
} from "react-router-dom";

import "services/api/axios";

import Cookies from "js-cookie";

// import redux
import { useDispatch } from "react-redux";
import {
    changeMode,
    LocationObj,
    ModeState,
    setLocation,
    setLocationLatLng
} from "services/redux/site/site";
import { AppDispatch } from "services/redux/store";

import * as Pages from "pages";
import { RootLayout } from "layouts";

// import geo location
// @ts-ignore
import useGeoLocation from "react-ipgeolocation";
import getFormattedAddress from "utils/helpers/getFormattedAddress";
import { setIncidentLocation } from "services/redux/incidentForm/incidentForm";

// define routes
const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<RootLayout />} errorElement={<Pages.Error />}>
            {/* main page */}
            <Route index element={<Pages.Feed />} />
            {/* incidents */}
            <Route path="incidents" element={<Pages.Incidents />} />
            {/* Login page */}
            <Route path="login" element={<Pages.Login />} />
            {/* Signup page */}
            <Route path="signup" element={<Pages.Signup />} />
            {/* thread post */}
            <Route path="thread" element={<Pages.ThreadPostPage />} />
            {/* profile page */}

            <Route path="profile">
                <Route index element={<Pages.Profile />} />
                <Route path=":id">
                    <Route index element={<Pages.Profile />} />
                    <Route
                        path="followers/:backto"
                        element={<Pages.FollowersPage />}
                    />
                    <Route
                        path="following/:backto"
                        element={<Pages.FollowingPage />}
                    />
                    {/* <Route
                        path="indirect-followers"
                        element={<Pages.IndirectFollowersPage />}
                    /> */}
                </Route>
            </Route>

            <Route path="search/:search" element={<Pages.SearchPage />} />

            <Route path="add-user" element={<Pages.AddNewAccount />} />
            {/* <Route path="add-new-user" element={<Pages.AddUsersPage />} /> */}

            {/* community sections */}
            <Route path="communities">
                <Route index element={<Pages.CommunityListing />} />
                <Route path=":id">
                    <Route index element={<Pages.Community />} />

                    <Route
                        path="members"
                        element={<Pages.CommunityMembersPage />}
                    />
                </Route>
                <Route
                    path="create-community"
                    element={<Pages.CreateCommunity />}
                />
            </Route>
            {/* privacy page */}
            <Route path="privacy" element={<Pages.Privacy />} />
            {/* terms page */}
            <Route path="terms" element={<Pages.Terms />} />
            {/* topics page */}
            <Route path="topics" element={<Pages.Topics />} />

            {/* chat */}
            <Route path="chat">
                <Route index element={<Pages.ChatList />} />
                <Route path=":id" element={<Pages.Chat />} />
            </Route>

            {/* trending */}
            <Route path="trending">
                <Route index element={<Pages.Trending />} />
                <Route path="incidents" element={<Pages.TrendingIncidents />} />
            </Route>
            {/* trending */}
            <Route path="placedetails/:name" element={<Pages.PlaceDetails />} />
            {/* trending */}
            <Route path="hashtag/:name" element={<Pages.Hashtag />} />
            {/* momeento-mark */}
            <Route path="momentmark" element={<Pages.MomeentoMark />} />
            {/* help */}
            <Route path="help" element={<Pages.Help />} />

            <Route path="map">
                <Route index element={<Pages.Map />} />
                <Route path="places" element={<Pages.PlacesMap />} />
                <Route path="hashtag" element={<Pages.HashtagMap />} />
            </Route>

            {/* notifications page */}
            <Route path="notifications" element={<Pages.NotificationsPage />} />
            {/* activity page */}
            <Route path="activity" element={<Pages.Activity />} />
            {/* settings sections */}
            <Route path="settings">
                <Route index element={<Pages.Settings />} />
                <Route path="messages" element={<Pages.Messages />} />
                <Route path="notifications" element={<Pages.Notifications />} />
                <Route path="langs" element={<Pages.Languages />} />
                {/* account routes in settings */}
                <Route path="account">
                    <Route index element={<Pages.AccountSettings />} />
                    <Route path="info" element={<Pages.AccountInfo />} />
                    <Route path="password" element={<Pages.ChangePswd />} />
                    <Route path="delete" element={<Pages.DeleteAccount />} />
                </Route>
                {/* prefrence */}
                <Route path="prefrence">
                    <Route index element={<Pages.Prefrence />} />
                    <Route path="block" element={<Pages.BlockUsers />} />
                    <Route path="mute" element={<Pages.MuteUsers />} />
                </Route>
            </Route>
        </Route>
    )
);

function App() {
    const dispatch = useDispatch<AppDispatch>();
    const modeCk = Cookies.get("mode");

    const location = useGeoLocation();
    useEffect(() => {
        dispatch(setLocation(location.country));
    }, [location]);

    const setLocationAddress = (location: LocationObj) => {
        dispatch(setLocationLatLng(location));
        dispatch(setIncidentLocation(location));
    };
    const getLocation = () => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const latLng = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                getFormattedAddress(latLng, setLocationAddress);
            },
            (error) => {
                console.error("Error getting user location:", error);
            }
        );
    };
    useEffect(() => {
        getLocation();
    }, []);

    useEffect(() => {
        // check for mode cookie
        if (!modeCk) {
            Cookies.set("mode", "light", { expires: 365 });
        } else {
            dispatch(changeMode(modeCk as ModeState));
        }
    }, []);

    return <RouterProvider router={router} />;
}

export default App;
